document.addEventListener('DOMContentLoaded', () => {
  gsap.registerPlugin(Draggable);

  // Elems
  const wrapper = document.querySelector('.container-slide');
  const sliderContainer = document.querySelector('.slides-wrapper');
  const slides = Array.from(sliderContainer.querySelectorAll('.slide'));
  const titlesWrappers = Array.from(document.querySelectorAll('.title-wrapper'));
  const prevBtn = document.querySelector('.prev');
  const nextBtn = document.querySelector('.next');

  let currentIndex = 0;

  // Calcul des slides et du positionnement
  const getStep = () => {
    const w = slides[0].offsetWidth;
    const g = parseFloat(getComputedStyle(sliderContainer).gap) || 0;
    return w + g;
  };

  // Gestion du centre !
  function getCenterX() {
    const style = getComputedStyle(wrapper);
    const padL = parseFloat(style.paddingLeft);
    const padR = parseFloat(style.paddingRight);
    const contentWidth = wrapper.clientWidth - padL - padR;
    const slideW = slides[0].offsetWidth;
    return (contentWidth / 2) - (slideW / 2);
  }

  // Calcul du positionnement des titres en hauteur
  const getOffsetY = () => {
    const w = window.innerWidth;
    if (w <= 480) return 40;
    if (w <= 768) return 40;
    if (w <= 1024) return 70;
    if (w <= 1440) return 80;
    return 75;
  };

  function updateSliderVisuals() {
    const centerX = getCenterX();
    const step = getStep();
    const offsetY = getOffsetY();

    // centre la slide active
    gsap.to(sliderContainer, {
      x: centerX - currentIndex * getStep(),
      duration: 0.5,
      ease: 'power2.inOut'
    });

    // empile et ajuste l'opacité des titres
    titlesWrappers.forEach((tw, idx) => {
      const titleEl = tw.querySelector('.title');
      const y = (idx - currentIndex) * offsetY;
      gsap.to(tw, {
        y,
        duration: 0.5,
        ease: 'power1.out'
      });
      gsap.to(titleEl, {
        opacity: idx === currentIndex ? 1 : 0.5,
        duration: 0.5,
        ease: 'power1.out'
      });
    });
  }

  // bornes du drag
  const bounds = {
    maxX: getCenterX(),
    minX: getCenterX() - (slides.length - 1) * getStep()
  };

  const dragInstance = Draggable.create(sliderContainer, {
    type: 'x',
    trigger: wrapper,
    bounds,
    inertia: false,
    snap: {
      x(end) {
        return Math.round((end - bounds.maxX) / getStep()) * getStep() + bounds.maxX;
      }
    },
    onDragStart() { wrapper.style.cursor = 'grabbing'; },
    onDragEnd() {
      wrapper.style.cursor = 'grab';
      currentIndex = Math.round((bounds.maxX - this.x) / getStep());
      updateSliderVisuals();
      this.update();
    }
  })[0];

  function goTo(idx) {
    currentIndex = (idx + slides.length) % slides.length;
    updateSliderVisuals();
    dragInstance.update();
  }
  prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
  nextBtn.addEventListener('click', () => goTo(currentIndex + 1));

  window.addEventListener('resize', () => {
    bounds.maxX = getCenterX();
    bounds.minX = getCenterX() - (slides.length - 1) * getStep();
    dragInstance.applyBounds(bounds);
    updateSliderVisuals();
  });

  // init
  updateSliderVisuals();
});
